import { useEffect, useRef, useState } from "react";
import { Eye, Monitor, Smartphone } from "lucide-react";
import { VirtualGuideWidget } from "@/components/VirtualGuideWidget";
import { Smile } from "@/components/Smile";
import { pill } from "./chatbot/fields";

/* Live preview of the Virtual Guide draft — the real panel, sandboxed (nothing is sent). Position/colours come from the Chatbot's published settings. */
export const VgPreviewPane = ({ draft }) => {
  const [open, setOpen] = useState(true);
  const [mobile, setMobile] = useState(false);
  const [frame, setFrame] = useState(null);
  const ref = useRef(null);
  const height = mobile ? 560 : Math.min(1020, Math.round(480 * (Number(draft.size || 100) / 100) + 80));
  useEffect(() => {
    const el = ref.current; if (!el) return undefined;
    const measure = () => setFrame({ w: el.clientWidth, h: el.clientHeight });
    measure();
    const ro = new ResizeObserver(measure); ro.observe(el);
    return () => ro.disconnect();
  }, [mobile, height]);
  return (
    <div className="lg:sticky lg:top-4" data-testid="vg-preview">
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="text-xs uppercase tracking-widest text-muted-foreground flex items-center gap-1.5"><Eye size={12} /> Virtual Guide preview (draft)</p>
        <div className="flex gap-1.5">
          <button type="button" data-testid="vg-preview-device" onClick={() => setMobile((m) => !m)} className={`${pill} border border-border bg-white`}>{mobile ? <Smartphone size={11} /> : <Monitor size={11} />} {mobile ? "Phone" : "Desktop"}</button>
          <button type="button" data-testid="vg-preview-toggle" onClick={() => setOpen((o) => !o)} className={`${pill} border border-border bg-white`}>{open ? "Show closed" : "Show opened"}</button>
        </div>
      </div>
      <div ref={ref} data-testid="vg-preview-frame" style={{ height }} className={`relative mx-auto overflow-hidden rounded-2xl border border-[#1A2E26]/15 bg-[#EDECE3] shadow-inner ${mobile ? "w-[320px]" : "w-full"}`}>
        <div className="absolute inset-x-0 top-0 h-10 bg-white/70 border-b border-[#1A2E26]/10 flex items-center px-4 gap-2"><Smile size={14} /><span className="text-[11px] font-serif text-[#1A2E26]">Sree Siddha Vignana Sadhana · 🙂 Positive Life</span></div>
        <div className="absolute left-4 right-4 top-14 space-y-2 opacity-60"><div className="h-4 w-1/2 rounded bg-[#1A2E26]/15" /><div className="h-2 w-2/3 rounded bg-[#1A2E26]/10" /><div className="h-2 w-3/4 rounded bg-[#1A2E26]/10" /></div>
        {frame && <VirtualGuideWidget key={`${draft.placement}-${draft.theme}-${draft.size}-${mobile}`} preview={{ cfg: { ...draft, enabled: true }, open, mobile, frame }} />}
      </div>
      <p className="mt-2 text-[11px] text-muted-foreground">Walk through the welcome, voice/typing choice and Pre-Conversation Setup exactly as a participant will see them. Questions and answers are illustrative here — nothing is sent.</p>
    </div>
  );
};
